module.exports = __webpack_public_path__ + "static/media/range-booth.3a0ed590.svg";